import { MARQUEE_ITEMS } from "../../data/content";

export default function Marquee() {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            className="overflow-hidden border-y border-gold/15 bg-navy py-6"
            aria-hidden="true"
            data-testid="markets-marquee"
        >
            <div className="marquee-track flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {items.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="whitespace-nowrap px-8 font-serif text-2xl font-light italic text-ivory/85 md:text-3xl">
                                    {item}
                                </span>
                                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
